import { Button as FloraButton } from '@grupoboticario/flora-react';
import { ThreeLinkedDotsIcon } from '@grupoboticario/flora-react-icons';
import { GuideCarouselItems as S } from '../CycleGuide.style';
import { formatShortDate } from 'core/utilities';
import Logo from 'ui/components/primitives/Logo/Logo.styles';
import { catalogButtonClick } from '../events';
import type { ResellerAvailableCatalogs } from 'core/services/bff';
import { imgBackup } from 'core/use-cases/content/hooks/const';

type TCycleGuideBotSliderItem = {
  catalogWithPosition: ResellerAvailableCatalogs;
  setOpenShareModal(arg: boolean): void;
  setSelectedGuide(catalogWithPosition: ResellerAvailableCatalogs): void;
  viewBox: string;
  paths: string[];
};

const CycleGuideBotSliderItem = (props: TCycleGuideBotSliderItem) => {
  const brand = props.catalogWithPosition?.brand?.toUpperCase() as keyof typeof imgBackup;

  return (
    <S.Card>
      <S.Container>
        <S.DivImg>
          <S.ImgGuide
            src={props.catalogWithPosition?.banner}
            alt="Imagem do guia"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = imgBackup[brand] ?? imgBackup['BOTICARIO'];
            }}
          />
        </S.DivImg>
        <div>
          <S.Content>
            <Logo
              preserveAspectRatio="xMidYMid meet"
              viewBox={props.viewBox}
              xmlns="http://www.w3.org/2000/svg"
            >
              {props.paths.map((path: string) => (
                <path key={`default-${path}`} d={path} fillRule="evenodd" />
              ))}
            </Logo>
          </S.Content>
          <S.Content>
            <S.CycleInfo>
              <span>
                Ciclo {props.catalogWithPosition?.cycleNumber} -{' '}
                {formatShortDate(props.catalogWithPosition?.cycleStart || '')} a{' '}
                {formatShortDate(props.catalogWithPosition?.cycleEnd || '')}
              </span>
            </S.CycleInfo>
          </S.Content>
          <S.Content>
            <S.CycleInfo>
              <FloraButton
                data-flora="button"
                data-flora-text="compartilhar"
                rightIcon={<ThreeLinkedDotsIcon size={16} />}
                onClick={() => {
                  props.setOpenShareModal(true);
                  props.setSelectedGuide(props.catalogWithPosition);
                  catalogButtonClick(
                    props.catalogWithPosition,
                    'click:abrir-modal-compartilhamento',
                  );
                }}
              >
                Compartilhar catálogo
              </FloraButton>
            </S.CycleInfo>
          </S.Content>
        </div>
      </S.Container>
    </S.Card>
  );
};

export default CycleGuideBotSliderItem;
